<template>
  <b-row class="about-abouts">
    <baidu-map
      class="bm-view map"
      :center="{ lng: 116.240752, lat: 39.95948 }"
      :zoom="20"
      :scroll-wheel-zoom="true"
    >
      <bm-marker
        :position="{ lng: 116.240752, lat: 39.95948 }"
        :dragging="true"
        animation="BMAP_ANIMATION_BOUNCE"
      />
    </baidu-map>
    <div class="abouts-texts">
      <h2>汇才汇能（北京）科技有限公司</h2>
      <div class="about-data">
        <i class="fa-phone"></i>
        <p>18518629457</p>
      </div>
      <div class="about-data">
        <i class="fa-mess"></i>
        <p>hchn_hr@163.com</p>
      </div>
      <!-- <div class="about-data">
        <i class="fa-www"></i>
        <p>market@huicaihuineng.com</p>
      </div> -->
      <div class="about-data">
        <i class="fa-wz"></i>
        <p>北京市海淀区杏石口路80号B区1号楼一层125号</p>
      </div>
    </div>
  </b-row>
</template>
<script>
import publicChange from "@/assets/js/index.js";
import iconMap from "@/assets/img/aboutUs/pos.png";
export default {
  name: "aboutUs",
  data() {
    return {
      iconMaps: iconMap
    };
  },
  methods: {
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    },
    tabClick(value) {
      this.tab = value;
    }
  }
};
</script>
